import React, { useState } from 'react';

import { Container, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import EntryTable from './EntryTable';

function TransactionsPage({ onNavigate }) {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    const handlePreviousMonth = () => {
        if (currentMonth === 0) { // Janvier
            setCurrentMonth(11); // Décembre
            setCurrentYear(currentYear - 1); // Année précédente
        } else {
            setCurrentMonth(currentMonth - 1);
        }
    };

    const handleNextMonth = () => {
        if (currentMonth === 11) { // Décembre
            setCurrentMonth(0); // Janvier
            setCurrentYear(currentYear + 1); // Année suivante
        } else {
            setCurrentMonth(currentMonth + 1);
        }
    };

    return (
        <>
            <Typography variant='h4' align='center' style={{ textTransform: 'capitalize' }}>{new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' })}</Typography>
            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
                <Button onClick={handlePreviousMonth}>Préc.</Button>
                <Button onClick={handleNextMonth}>Suiv.</Button>
            </Stack>

            <EntryTable currentMonth={currentMonth} currentYear={currentYear} />
        </>
    );

}

export default TransactionsPage;